import { ConfigContext } from "@/react/story/providers/ConfigContext";
import { type ReactNode, useMemo, useState } from "react";

type Props = {
    temporaryEndpoint: string;
    isOnline: boolean;
    storyPermalink: string;
    children: ReactNode;
}

export default function ConfigProvider(props: Props) {
    const [ isLoading, setIsLoading ] = useState<boolean>(false);
    const [ isFullscreen, setIsFullscreen ] = useState<boolean>(false);

    const context = useMemo(() => ({
        isLoading,
        setIsLoading,
        isFullscreen,
        toggleFullscreen: () => setIsFullscreen(p => !p),
        temporaryEndpoint: props.temporaryEndpoint,
        isOnline: props.isOnline,
        storyPermalink: props.storyPermalink,
    }), [ isLoading, isFullscreen, props.temporaryEndpoint, props.isOnline, props.storyPermalink ]);

    return (
        <ConfigContext.Provider value={context}>
            {props.children}
        </ConfigContext.Provider>
    );
}
